import { Api } from '../axios-config'
import { IPerfil } from '../perfil/PerfilService'

export interface IUsuario_Perfil {
    idPerfil: number,
    iUsuario: number
}
export type TUsuario_Perfil = {
    idPerfil: number,
    iUsuario: number
}

const getAllByCnpj = async (cnpj: string | undefined | null): Promise<IPerfil[] | Error> => {
    try {
        const { data } = await Api.get(`Perfil/cnpj?cnpj=${cnpj}&estado=true`);
        if (data) {
            return data;
        }

        return new Error('Erro ao listar os registros');
    } catch (error) {
        console.error(error);

        //mostrar a mensagem que o back end retornou, caso não tenha retorna uma mensagem padrão
        return new Error((error as { message: string }).message || 'Erro ao listar os registros');
    }
}

const getAllByCnpjs = async (cnpjs: string[]): Promise<IPerfil[] | Error> => {
    try {
        var url = `Perfil/cnpjs?`;
        cnpjs.map((cnpj, index) => {
            url += `cnpjs=${cnpj}`;
            if (index !== cnpjs.length - 1) {
                url += "&";
            }
        });
        const { data } = await Api.get(url);
        if (data) {
            return data;
        }

        return new Error('Erro ao listar os registros');
    } catch (error) {
        console.error(error);

        //mostrar a mensagem que o back end retornou, caso não tenha retorna uma mensagem padrão
        return new Error((error as { message: string }).message || 'Erro ao listar os registros');
    }
}

const getByIdUsuario = async (idUsuario: number): Promise<IUsuario_Perfil[] | Error> => {
    try {
        const { data } = await Api.get(`Usuario_perfil/pesquisar?idUsuario=${idUsuario}`);

        if (data) {
            return data;
        }

        return new Error('Erro ao listar os registros');
    } catch (error) {
        console.error(error);

        //mostrar a mensagem que o back end retornou, caso não tenha retorna uma mensagem padrão
        return new Error((error as { message: string }).message || 'Erro ao listar os registros');
    }
}
const create = async (idUsuario: number, ids: Array<{ idUsuario: number, idPerfil: number }>) => {
    try {
        const { data } = await Api.post(`Usuario_perfil?idUsuario=${idUsuario}`, ids);

        if (data) {
            return data;
        }

        return new Error('Erro ao cadastrar os registros');
    } catch (error) {
        console.error(error);

        //mostrar a mensagem que o back end retornou, caso não tenha retorna uma mensagem padrão
        return new Error((error as { message: string }).message || 'Erro ao cadastrar os registros');
    }
}
const deleteByIdUsuario = async (idUsuario: number) => {
    try {
        const { data } = await Api.delete(`Usuario_perfil?idUsuario=${idUsuario}`);

        if (data) {
            return data;
        }

        return new Error('Erro ao apagar os relacionamentos');
    } catch (error) {
        console.error(error);

        //mostrar a mensagem que o back end retornou, caso não tenha retorna uma mensagem padrão
        return new Error((error as { message: string }).message || 'Erro ao apagar os relacionamentos');
    }
}

export const Usuario_Perfil_Service = {
    getAllByCnpj,
    getAllByCnpjs,
    getByIdUsuario,
    create,
    deleteByIdUsuario,
}